import { IUpdateCovid19IncidentFlagAction } from '../actions/update-covid-incident-flag';
import { ITicketsState } from '../state';

export type UpdateCovid19IncidentFlagAction
    = IUpdateCovid19IncidentFlagAction;

const update = (state: ITicketsState, action: UpdateCovid19IncidentFlagAction) => ({
    ...state,
    covid19IncidentFlag: action.flag
});

export const updateCovid19IncidentFlagReducer = (state, action) => update(state, action);
